module.exports = __webpack_public_path__ + "img/画板 13.109f37e2.jpg";